import type * as React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
  width?: number;
};

export const MooneLogo = ({ width = 140, ...props }: Props) => {
  // Aspect ratio: 920 / 236 ≈ 3.898
  const height = width / (920 / 236);

  return (
    <svg
      viewBox="0 0 920 236"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 1.5,
      }}
      width={width}
      height={height}
      {...props}
    >
      <g transform="matrix(1,0,0,1,-101.295,-621.603)">
        <g transform="matrix(1.70042,0,0,1.70042,-251.413,14.699)">
          <g transform="matrix(0.599524,0,0,0.599524,-74.275,79.6015)">
            <circle
              cx="872.175"
              cy="673.544"
              r="3.805"
              style={{ fill: "black", stroke: "black", strokeWidth: "2.94px" }}
            />
          </g>
          <g>
            <g transform="matrix(0.58809,-0,-0,0.58809,207.424,356.914)">
              <use
                xlinkHref="#_Image1"
                x="196.001"
                y="16.616"
                width="166px"
                height="190px"
              />
            </g>
            <g transform="matrix(1,0,0,1,-128.215,0.381029)">
              <path
                d="M481.897,465.176C481.685,464.822 481.476,464.464 481.271,464.102C477.092,456.737 475.002,448.35 475.002,438.941C475.002,429.41 477.096,421.015 481.282,413.757C485.469,406.499 491.146,400.791 498.312,396.635C505.479,392.479 513.648,390.401 522.82,390.401C527.702,390.401 532.309,390.99 536.642,392.167C533.804,391.668 530.886,391.408 527.908,391.408C499.809,391.408 476.997,414.55 476.997,443.054C476.997,450.968 478.755,458.469 481.897,465.176Z"
                style={{ fill: "black" }}
              />
            </g>
            <g transform="matrix(0.269665,0,0,0.269665,110.509,250.493)">
              <path
                d="M1102.94,540.953C1178.88,558.55 1235.56,626.682 1235.56,707.946C1235.56,802.55 1158.75,879.356 1064.15,879.356C987.634,879.356 922.761,829.113 900.752,759.851C928.357,793.39 970.174,814.785 1016.95,814.785C1099.97,814.785 1167.38,747.382 1167.38,664.359C1167.38,613.301 1141.88,568.15 1102.94,540.953Z"
                style={{ fill: "black" }}
              />
            </g>
          </g>
          <g transform="matrix(1,0,0,1,-132.619,0)">
            <path
              d="M634.718,487.624C625.563,487.624 617.394,485.545 610.212,481.387C603.029,477.229 597.348,471.468 593.169,464.102C588.99,456.737 586.901,448.35 586.901,438.941C586.901,429.41 588.994,421.015 593.18,413.757C597.367,406.499 603.044,400.791 610.21,396.635C617.377,392.479 625.546,390.401 634.718,390.401C643.89,390.401 652.091,392.478 659.322,396.631C666.552,400.784 672.229,406.488 676.352,413.741C680.474,420.995 682.536,429.395 682.536,438.941C682.536,448.365 680.477,456.756 676.359,464.114C672.241,471.472 666.56,477.229 659.315,481.387C652.07,485.545 643.871,487.624 634.718,487.624ZM634.718,479.43C642.096,479.43 648.7,477.728 654.53,474.325C660.359,470.922 664.945,466.163 668.287,460.048C671.63,453.934 673.301,446.899 673.301,438.944C673.301,430.878 671.63,423.819 668.287,417.765C664.945,411.712 660.359,407.004 654.53,403.641C648.7,400.277 642.106,398.596 634.75,398.596C627.391,398.596 620.817,400.277 615.028,403.641C609.24,407.004 604.644,411.712 601.24,417.765C597.837,423.819 596.136,430.878 596.136,438.944C596.136,446.899 597.837,453.934 601.24,460.048C604.644,466.163 609.238,470.922 615.024,474.325C620.81,477.728 627.375,479.43 634.718,479.43Z"
              style={{ fill: "black", fillRule: "nonzero" }}
            />
          </g>
          <g transform="matrix(1,0,0,1,-148.632,0)">
            <path
              d="M755.911,390.401C763.778,390.401 770.606,391.909 776.395,394.926C782.184,397.942 786.709,402.457 789.969,408.47C793.23,414.484 794.861,421.974 794.861,430.941L794.861,486.891L785.689,486.891L785.689,431.735C785.689,420.893 782.968,412.68 777.526,407.094C772.084,401.509 764.451,398.716 754.627,398.716C747.167,398.716 740.706,400.225 735.243,403.242C729.78,406.259 725.591,410.54 722.677,416.083C719.763,421.626 718.306,428.23 718.306,435.894L718.306,486.891L709.134,486.891L709.134,391.135L718,391.135L718,417.794L716.655,414.739C719.63,407.156 724.491,401.205 731.237,396.883C737.983,392.562 746.208,390.401 755.911,390.401Z"
              style={{ fill: "black", fillRule: "nonzero" }}
            />
          </g>
          <g transform="matrix(1,0,0,1,-164.522,0)">
            <path
              d="M870.621,487.624C860.96,487.624 852.43,485.545 845.031,481.387C837.633,477.229 831.834,471.472 827.635,464.114C823.436,456.756 821.336,448.369 821.336,438.953C821.336,429.454 823.313,421.066 827.268,413.79C831.222,406.513 836.675,400.796 843.626,396.638C850.576,392.48 858.413,390.401 867.136,390.401C875.859,390.401 883.665,392.429 890.554,396.485C897.444,400.541 902.866,406.197 906.82,413.453C910.775,420.709 912.752,429.087 912.752,438.586C912.752,438.953 912.742,439.37 912.721,439.838C912.7,440.306 912.669,440.785 912.629,441.274L828.003,441.274L828.003,434.12L907.736,434.12L904.067,437.545C904.109,430.045 902.52,423.34 899.299,417.429C896.079,411.517 891.707,406.87 886.183,403.487C880.66,400.104 874.311,398.413 867.136,398.413C860.043,398.413 853.704,400.104 848.12,403.487C842.535,406.87 838.163,411.527 835.004,417.459C831.844,423.39 830.265,430.147 830.265,437.729L830.265,439.32C830.265,447.146 831.997,454.086 835.462,460.14C838.928,466.193 843.718,470.922 849.832,474.325C855.947,477.728 862.938,479.43 870.805,479.43C876.919,479.43 882.636,478.309 887.956,476.068C893.276,473.826 897.77,470.443 901.439,465.918L906.819,471.972C902.581,477.108 897.323,481.001 891.045,483.65C884.767,486.3 877.959,487.624 870.621,487.624Z"
              style={{ fill: "black", fillRule: "nonzero" }}
            />
          </g>
          <g transform="matrix(0.780344,0,0,0.780344,28.572,-67.8455)">
            <path
              d="M318.484,661.838L387.386,544.323L406.987,544.323L407.066,609.708L406.951,609.905C401.188,619.896 398.307,637.037 398.307,650.157C398.307,663.109 401.183,679.309 406.936,689.447L407.15,689.822L407.189,711.585L384.246,711.585L384.058,589.486L323.561,691.361L312.622,691.361L252.139,590.493L252.139,711.585L229.196,711.585L229.196,544.323L248.797,544.323L318.484,661.838Z"
              style={{ fill: "black", fillRule: "nonzero" }}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
